// react
import React from 'react';
import { FormattedMessage } from 'react-intl';

// third-party
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

// application
import PageHeader from '../shared/PageHeader';

// data stubs
import theme from '../../data/theme';

function SitePageTerms() {
    const breadcrumb = [
        { title: <FormattedMessage id="header.home" defaultMessage="Home" />, url: '' },
        { title: <FormattedMessage id="header.termsAndConditions" defaultMessage="Terms And Conditions" />, url: '' },
    ];

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Terms And Conditions — ${theme.name}`}</title>
            </Helmet>

            <PageHeader breadcrumb={breadcrumb} />

            <div className="block">
                <div className="container">
                    <div className="document">
                        <div className="document__header">
                            <h1 className="document__title"><FormattedMessage id="header.termsAndConditions" defaultMessage="Terms And Conditions" /></h1>
                            <div className="document__subtitle"><FormattedMessage id="header.termsAndConditionsSubtitle" defaultMessage="This Agreement was last modified on 27 May 2018." /></div>
                        </div>
                        <div className="document__content typography">
                            <p>
                            <FormattedMessage id="footer.termsAndConditionsParagraph1" defaultMessage="Chez Noumï Distribution, nous accordons une grande importance à la protection de vos données personnelles. Cette politique de confidentialité explique quelles informations nous collectons, comment nous les utilisons et quels sont vos droits concernant vos données." />
                            </p>

                            <h2><FormattedMessage id="footer.termsAndConditionsParagraph2Title" defaultMessage="Informations collectées" /></h2>
                            <FormattedMessage id="footer.termsAndConditionsParagraph2" defaultMessage="Nous collectons différentes catégories de données lorsque vous utilisez notre site :" />
                            <ol>
                                <li>
                                    <strong><FormattedMessage id="footer.termsAndConditionsParagraph2Item1" defaultMessage="Données personnelles fournies volontairement" /></strong>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph2Item1Description" defaultMessage="Nom, prénom, adresse email, adresse postale, numéro de téléphone, informations de paiement." />
                                </li>
                                <li>
                                    <strong><FormattedMessage id="footer.termsAndConditionsParagraph2Item2" defaultMessage="Données collectées automatiquement" /></strong>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph2Item2Description" defaultMessage="Adresse IP, type de navigateur, pages visitées, durée de navigation, préférences d’achat." />

                                </li>
                                <li>
                                    <strong><FormattedMessage id="footer.termsAndConditionsParagraph2Item3" defaultMessage="Données issues des cookies" /></strong>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph2Item3Description" defaultMessage="We use cookies to improve your experience and personalize your browsing." />
                                </li>
                            </ol>

                            <h2><FormattedMessage id="footer.termsAndConditionsParagraph3Title" defaultMessage="Utilisation des données" /></h2>
                            <FormattedMessage id="footer.termsAndConditionsParagraph3" defaultMessage="Nous utilisons vos informations pour :" />
                            <ol>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph3Item1" defaultMessage="Gérer et traiter vos commandes." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph3Item2" defaultMessage="Améliorer notre site et nos services." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph3Item3" defaultMessage="Assurer la sécurité et prévenir les fraudes." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph3Item4" defaultMessage="Répondre à vos demandes et assurer un service client efficace." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph3Item5" defaultMessage="Vous envoyer des offres promotionnelles si vous avez donné votre consentement." />
                                </li>
                            </ol>

                            <h2><FormattedMessage id="footer.termsAndConditionsParagraph4Title" defaultMessage="Partage des données" /></h2>
                            <FormattedMessage id="footer.termsAndConditionsParagraph4" defaultMessage="Nous ne vendons ni ne louons vos données personnelles. Cependant, nous pouvons partager certaines informations avec :" />
                            <ol>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph4Item1" defaultMessage="Prestataires de services (ex. : services de paiement, transporteurs, outils d’emailing)." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph4Item2" defaultMessage="Améliorer notre site et nos services." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph4Item3" defaultMessage="Autorités légales si la loi nous y oblige." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph4Item4" defaultMessage="Partenaires commerciaux uniquement si vous avez donné votre accord." />
                                </li>
                            </ol>

                            <h2><FormattedMessage id="footer.termsAndConditionsParagraph5Title" defaultMessage="Vos droits" /></h2>
                            <FormattedMessage id="footer.termsAndConditionsParagraph5" defaultMessage="Conformément au Règlement Général sur la Protection des Données (RGPD), vous avez le droit de :" />

                            <ol>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph5Item1" defaultMessage="Accéder à vos données personnelles." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph5Item2" defaultMessage="Corriger ou mettre à jour vos informations." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph5Item3" defaultMessage="Demander la suppression de vos données." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph5Item4" defaultMessage="Vous opposer à l'utilisation de vos données à des fins marketing." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph5Item5" defaultMessage="Retirer votre consentement à tout moment." />
                                </li>
                            </ol>

                            <h2><FormattedMessage id="footer.termsAndConditionsParagraph6Title" defaultMessage="Cookies and similar technologies" /></h2>
                            <FormattedMessage id="footer.termsAndConditionsParagraph6" defaultMessage="We use cookies to:" />
                            <ol>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph6Item1" defaultMessage="Assurer le bon fonctionnement du site." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph6Item2" defaultMessage="Mémoriser vos préférences." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph6Item3" defaultMessage="Analyser les performances et améliorer nos services." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph6Item4" defaultMessage="Répondre à vos demandes et assurer un service client efficace." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph6Item5" defaultMessage="Vous envoyer des offres promotionnelles si vous avez donné votre consentement." />
                                </li>
                            </ol>
                            <FormattedMessage id="footer.termsAndConditionsParagraph6Contact" defaultMessage="Pour exercer ces droits, vous pouvez nous contacter à info@noumidistribution.com" />
                            <h2><FormattedMessage id="footer.termsAndConditionsParagraph7Title" defaultMessage="Cookies et technologies similaires" /></h2>
                            <FormattedMessage id="footer.termsAndConditionsParagraph7Description" defaultMessage="Nous utilisons des cookies pour :" />
                            <ol>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph6Item1" defaultMessage="Assurer le bon fonctionnement du site." />
                                </li>
                                <li>
                                <FormattedMessage id="footer.termsAndConditionsParagraph7Item2" defaultMessage="Mémoriser vos préférences." />
                                </li>
                                <li>
                                    <FormattedMessage id="footer.termsAndConditionsParagraph7Item3" defaultMessage="Analyser les performances et améliorer nos services." />
                                </li>

                            </ol>
                            <FormattedMessage id="footer.termsAndConditionsParagraph7Item4" defaultMessage="Vous pouvez gérer vos préférences en matière de cookies via les paramètres de votre navigateur." />


                            <h2><FormattedMessage id="footer.termsAndConditionsParagraph8Title" defaultMessage="Sécurité des données" /></h2>
                            <p><FormattedMessage id="footer.termsAndConditionsParagraph8Description" defaultMessage="Nous mettons en place des mesures de sécurité techniques et organisationnelles pour
                                protéger vos informations contre tout accès non autorisé, perte ou modification." /></p>
                            <h2><FormattedMessage id="footer.termsAndConditionsParagraph9Title" defaultMessage="Modifications de la politique de confidentialité" /></h2>
                            <p><FormattedMessage id="footer.termsAndConditionsParagraph9Description" defaultMessage="Nous nous réservons le droit de modifier cette politique à tout moment. Toute mise à jour sera publiée sur cette page avec une date de modification." /></p>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default SitePageTerms;
